/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


/*
 * ★見本のイベント購読は外した（2026-10-13）★
 * このファイルは今日まで読み込まれていなかった（theme.liquid のコメントの中にあった）。
 * 読み込むようにすると、見本に入っている console.log がすべて動き、
 * **お客様のカートの中身がブラウザのコンソールに出る**。
 * 必要なものだけ残す。
 */
// より確実な初期化
window.addEventListener('load', function() {
  setTimeout(function() {
    const checkedInputs = document.querySelectorAll('.no-js-checkbox:checked');
    checkedInputs.forEach(function(input) {
      const parts = input.id.split('--');
      const accordionId = parts[0].replace('-checkbox', '');
      
      const accordionBody = document.getElementById(accordionId);
      const trigger = document.querySelector(`[data-accordion-trigger="${accordionId}"]`);
      
      if (accordionBody && trigger) {
        accordionBody.style.display = 'block';
        accordionBody.style.visibility = 'visible';
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  }, 100);
});

/* ============================================================
 *  カートに追加したら、カートページへ移る（2026-10-13）
 * ------------------------------------------------------------
 *  ★なぜ要るか★
 *  お客様からのご指摘：「カートに追加したあと決済したいのに画面は商品ページのまま。
 *  決済がどこか分からず、追加できたのかも分からず、最初非常に混乱した」。
 *
 *  追加に成功すると画面のいちばん上に帯が出るが、押したボタンは600px以上下にあり、
 *  帯は5秒で自動的に消える（theme.js の popdownTimer）。
 *  押したところには記号しか残らなかった（btn-state-complete が空白だった）。
 *
 *  ★なぜ custom.js か★
 *  一、theme.js（テーマ本体・1.1MB）を触らないので、テーマ更新で消えない
 *  二、アプリの拡張機能に入れると3ブランド共通になる。これは N'S だけの話
 *  三、theme:cart:popdown は【追加に成功したとき】だけ飛ぶ。
 *      失敗すれば飛ばないので、失敗を成功に見せない
 *
 *  ★cart_style は触っていない★
 *  Pipeline の `compatible` は商品ページには効かない（theme.js に出てこない）。
 *  判定用の isAjaxDisabled もどこからも読まれていない。設定では直せない。
 * ============================================================ */
document.addEventListener('theme:cart:popdown', function () {
  if (/\/cart$/.test(location.pathname.replace(/\/+$/, ''))) return;
  window.location.href = window.Shopify && window.Shopify.routes
    ? window.Shopify.routes.root + 'cart'
    : '/cart';
});
